import * as swcHelpers from '@swc/helpers';
import { getMatchedDiscounts, getCartDiscountAmount } from './cart-discounts.js';

const calculatePrescription = (config, isPrescriptionInfoEnabled, variant, isPrescriptionValid, cartDiscounts)=>{
    if (!config || !Object.keys(config).length || !config.packPrice) {
        return {
            selectedProducts: [],
            packageQuantity: 0,
            totalDiscount: undefined,
            totalPrice: 0,
            totalCLBBPrice: 0
        };
    }
    const { leftEyeBoxSKU , leftEyeChecked , leftEyeBoxQuantity , leftEyeBoxAvailableQuantity , rightEyeBoxSKU , rightEyeChecked , rightEyeBoxQuantity , rightEyeBoxAvailableQuantity , hasHardQuantityLimit , clbbPrice , packPrice: { value: { centAmount: centAmount  } ,  } , prescriptionInfo ,  } = config;
    const hasDiscount = !!config.packPrice.discounted && !!config.packPrice.discounted.value && !!config.packPrice.discounted.value.centAmount;
    const discountedPackPrice = config.packPrice.discounted;
    const discountedCentAmount = discountedPackPrice && discountedPackPrice.value.centAmount;
    const selectedProducts = [];
    const calculatedPrices = [];
    const calculatedDiscountedPrices = [];
    if (isPrescriptionValid && leftEyeBoxQuantity && (leftEyeBoxAvailableQuantity || !hasHardQuantityLimit) && leftEyeChecked && leftEyeBoxSKU) {
        const totalPriceLeft = leftEyeBoxQuantity * centAmount;
        const leftLensSKU = {
            sku: leftEyeBoxSKU,
            quantity: leftEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'left'
            }
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            const { prescriptionExpiryDate , externalOptician  } = prescriptionInfo;
            leftLensSKU.customAttributes = swcHelpers.objectSpread({}, leftLensSKU.customAttributes, {
                prescriptionExpiryDate,
                externalOptician
            });
        }
        selectedProducts.push(leftLensSKU);
        calculatedPrices.push(totalPriceLeft);
        if (hasDiscount) {
            const totalDiscountLeft = totalPriceLeft - discountedCentAmount * leftEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountLeft);
        }
    }
    if (isPrescriptionValid && rightEyeBoxQuantity && (rightEyeBoxAvailableQuantity || !hasHardQuantityLimit) && rightEyeChecked && rightEyeBoxSKU) {
        const totalPriceRight = rightEyeBoxQuantity * centAmount;
        const rightLensSKU = {
            sku: rightEyeBoxSKU,
            quantity: rightEyeBoxQuantity,
            customAttributes: {
                eyeSide: 'right'
            }
        };
        if (isPrescriptionInfoEnabled && prescriptionInfo) {
            const { prescriptionExpiryDate , externalOptician  } = prescriptionInfo;
            rightLensSKU.customAttributes = swcHelpers.objectSpread({}, rightLensSKU.customAttributes, {
                prescriptionExpiryDate,
                externalOptician
            });
        }
        selectedProducts.push(rightLensSKU);
        calculatedPrices.push(totalPriceRight);
        if (hasDiscount) {
            const totalDiscountRight = totalPriceRight - discountedCentAmount * rightEyeBoxQuantity;
            calculatedDiscountedPrices.push(totalDiscountRight);
        }
    }
    const calculatedPrice = calculatedPrices.reduce((a, b)=>a + b
    , 0);
    const totalPackDiscount = calculatedDiscountedPrices.reduce((a, b)=>a + b
    , 0);
    const calculatedDiscountPrice = totalPackDiscount && calculatedPrice - totalPackDiscount;
    /**
   * Cart discounts
   *
   * # Get applied discounts
   * 1. find the total amount of quantity
   * 2. find the discount closest to the total amount of quantity
   * 3. find the discount amount or percentage
   * 4. calculate the discount amount
   */ const totalQuantity = selectedProducts.reduce((acc, item)=>{
        var _quantity;
        const quantity = (_quantity = item.quantity) !== null && _quantity !== void 0 ? _quantity : 0;
        return acc + quantity;
    }, 0);
    const appliedDiscounts = getMatchedDiscounts(totalQuantity, {
        leftEyeChecked: config.leftEyeChecked,
        rightEyeChecked: config.rightEyeChecked,
        quantityDiscountItems: cartDiscounts
    });
    // Round down to whole number
    const packPrice = discountedCentAmount || centAmount;
    const cartDiscountAmount = getCartDiscountAmount(packPrice, appliedDiscounts);
    const calculatedTotalDiscount = calculatedDiscountPrice && calculatedDiscountPrice - cartDiscountAmount;
    const calculatedTotalPrice = calculatedPrice - cartDiscountAmount;
    // selectedProducts is eye side lenses i.e. max is two.
    // Hence multiplying the clbb subscripton price for one eye.
    const totalCLBBPrice = (clbbPrice !== null && clbbPrice !== void 0 ? clbbPrice : 0) * selectedProducts.length;
    const packageQuantity = config && config.packSize || variant.packageQuantity;
    return {
        selectedProducts,
        totalPrice: calculatedTotalPrice,
        totalCLBBPrice,
        totalDiscount: calculatedTotalDiscount,
        packageQuantity
    };
};

export { calculatePrescription };
//# sourceMappingURL=calculate-prescription.js.map
